import { render } from "./BestandsnachweisDialog.vue?vue&type=template&id=6ad73d2d&scoped=true"
import script from "./BestandsnachweisDialog.vue?vue&type=script&lang=js"
export * from "./BestandsnachweisDialog.vue?vue&type=script&lang=js"

import "./BestandsnachweisDialog.vue?vue&type=style&index=0&id=6ad73d2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad73d2d"]])

export default __exports__